var Component = require("!../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=script&index=0!./remark_query.vue"),
  /* template */
  require("!!../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/template-compiler?id=data-v-4548e3ec!../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=template&index=0!./remark_query.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/nav2/remark_query.vue
// module id = 701
// module chunks = 2